'use client';

import { cn } from '@core/utils';

import { AD_UNIT_IDS } from '@/constants/ad';
import { isBannerAdHidden, useAd } from '@/hooks/useAd';

export const HospitalDetailBannerAd = () => {
  const { containerRef, adState } = useAd(
    AD_UNIT_IDS.CONTENT_DETAIL_BOTTOM_BANNER,
    {
      type: 'banner',
    },
  );

  if (isBannerAdHidden(adState)) {
    return null;
  }

  return (
    <div className="flex justify-center p-20">
      <div
        ref={containerRef}
        className={cn(
          'overflow-hidden bg-Gray-100 flex-center',
          adState === 'idle' && 'invisible',
          adState === 'loading' && 'animate-pulse',
        )}
        style={{
          width: 300,
          height: 250,
        }}
      />
    </div>
  );
};
